var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecruitmentAgents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_176165_362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.33333 4C9.33333 1.794 7.53933 0 5.33333 0C3.12733 0 1.33333 1.794 1.33333 4C1.33333 6.206 3.12733 8 5.33333 8C7.53933 8 9.33333 6.206 9.33333 4ZM5.33333 6.66667C3.86267 6.66667 2.66667 5.47067 2.66667 4C2.66667 2.52933 3.86267 1.33333 5.33333 1.33333C6.804 1.33333 8 2.52933 8 4C8 5.47067 6.804 6.66667 5.33333 6.66667ZM3 9.33333H4.66667V10.6667H3C2.08133 10.6667 1.33333 11.4147 1.33333 12.3333V16H0V12.3333C0 10.6793 1.346 9.33333 3 9.33333ZM13 11.6H12.4V10.4H13C13.3307 10.4 13.6 10.6693 13.6 11C13.6 11.3307 13.3307 11.6 13 11.6ZM14 8H8C6.89533 8 6 8.89533 6 10V16H16V10C16 8.89533 15.1047 8 14 8ZM10.6667 14.6667H9.6V12.53H8.4V14.6667H7.33333V9.33333H8.4V11.4633H9.6V9.33333H10.6667V14.6667ZM13.992 12.3393C13.98 12.3473 13.98 12.3473 13.964 12.3587L14.6667 14.6667H13.504L12.9227 12.6667H12.4V14.6667H11.3333V9.33333H13C13.9207 9.33333 14.6667 10.0793 14.6667 11C14.6667 11.564 14.3847 12.0613 13.9553 12.3627C13.9713 12.3533 13.9793 12.3473 13.992 12.3393Z",
    fill: "#4D4D4D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_176165_362"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecruitmentAgents);
export default __webpack_public_path__ + "static/media/recruitmentAgents.a684bf1dbec6d64d4ddf09ff334e394f.svg";
export { ForwardRef as ReactComponent };